<template>
    <div class="partial-selector">
        <div class="edit-container">
            <div class="confirm-message">{{ translations.confirmMessage }}</div>
            <v-text-field
                class="text-input"
                v-model="partialInput"
                data-testid="partialInput"
                hide-details
                :error="error"
                @input="clearError"
            >
                <template #label>
                    <span class="house-label">{{translations.partialInputLabel}}</span>
                </template>
            </v-text-field>
            <div>
                <button
                    data-testid="partialSubmitButton"
                    class="confirm-number-button primary-hit fluid"
                    @click.prevent.stop="onSubmit">
                    {{ translations.submitLabel }}
                </button>
            </div>
        </div>
        <div class="list-container">
            <a
                data-testid="showPartialSuggestionsButton"
                @click.prevent.stop="showPartialSuggestions = !showPartialSuggestions"
            >
                <div class="range-sub-container">
                    <div class="range-list-toggle">{{ translations.displayAllPartials }}</div>
                    <ns-icon v-if="!showPartialSuggestions" icon-name="icon-chevron-down" />
                    <ns-icon v-else icon-name="icon-chevron-up" />
                </div>
            </a>

            <ul data-testid="partialSuggestions" class="range-list" v-if="showPartialSuggestions">
                <template v-if="partialSuggestions.length < 1">
                    <li class="no-bullet">{{ translations.noSuggestionsFound }}</li>
                </template>
                <template v-if="partialSuggestions.length > 0">
                    <li class="p-small" v-for="(suggestion, index) in partialSuggestions" :key="index">
                        {{ suggestion.addresstext }}
                        {{ suggestion.postcode }}
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
import { VTextField } from 'vuetify/lib';
import { NsIcon } from '@nuskin/ns-icon';

export default {
    components: {
        VTextField,
        NsIcon,
    },
    props: {
        error: {
            type: Boolean,
            default: false,
        },
        partialSuggestions: {
            type: Array,
            default: () => [],
        },
        translations: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            showPartialSuggestions: false,
            partialInput: '',
        }
    },
    methods: {
        clearError() {
            this.$emit('clear-error');
        },
        onSubmit() {
            this.$emit('partial-address-selected', this.partialInput)
        },
    },
}
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/vuetifyOverrides";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";

$color-list-border: map.get(colors.$baseColors, steel);
$color-interactive: map.get(colors.$baseColors, shells);

.validator-form {
    line-height: 16px !important;
}

.partial-selector {
    display: flex;
    flex-direction: column;
    align-items: start;
}

.list-container {
    text-align: center;

    a {
        color: $color-interactive;
        text-decoration: underline $color-interactive;
    }

    .range-sub-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-bottom: 5px;
        
        .range-list-toggle {
            margin-right: 5px;
        }
        
        ns-icon {
            color: $color-interactive;
        }
    }

    .range-list {
        padding: 15px;
        border: 1px solid $color-list-border;
        border-radius: 3px;
        list-style-position: inside;
        text-align: left;
        @include global.paragraph-s();

        .no-bullet {
            list-style-type: none;
        }
    }
}

// 0px - 657px
.edit-container,
.list-container {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    flex: 1;
}

.edit-container {
    margin-bottom: 40px;
}

@media screen and (min-width: 768px) {
    .partial-selector {
        flex-direction: row;
    }

    .edit-container,
    .list-container {
        flex-basis: 50%;
    }

    .edit-container {
        margin: 0;
    }

    .list-container {
        padding-left: 15px;
    }
}

.confirm-message {
    @include global.heading-2();
}

.text-input {
    margin-bottom: 20px;
    max-width: 366px;

    ::v-deep .v-text-field__slot {
        flex-direction: column;
    }

    .house-label {
        @include global.paragraph-m();
    }
}

.confirm-number-button {
    min-width: 285px;
    max-width: 285px;
}

</style>
